module.exports = __webpack_public_path__ + "img/project-6.7dec866d.png";